import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_BLOCK_FULL_SESSION_AVAILABILITY } from './block-full-session-availability.gql';

export function BlockFullSessionAvailability() {
  const [queryConfig] = useCampfireLazyQuery<any, {}>(GET_BLOCK_FULL_SESSION_AVAILABILITY);
  const [enabled, setEnabled] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryConfig({}).then((response) =>
      setEnabled(
        response.data?.vm.configItem?.configItemValue?.flagValue ?? response.data?.vm.configItem?.defaultValue ?? false
      )
    );
  }, []);

  const saveFetch = useCampfireFetch({ defer: true });
  const apiUrl = useApiUrl();

  const onSave = () => {
    saveFetch
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: 'block-full-session-availability',
          value: !enabled,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setEnabled(!enabled);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(enabled)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'block full session availability toggle' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Block Availability For Full Sessions
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            Volunteers can&apos;t indicate availability for sessions that have reached their maximum. Rosters where
            every session is full show as Full. Sessions without a maximum are never full. Admins and managers are not
            affected.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
